import React from 'react';
import type { Block } from '../../../types/parcours';

interface TimelineItem {
  year?: string;
  headline: string;
  text?: string;
  side?: 'left' | 'right';
  icon?: string;
  image?: string;
}

interface TimelineBlock extends Block {
  type: 'timeline';
  items?: TimelineItem[];
}

interface Props {
  block: TimelineBlock;
}

export default function TimelineBlock({ block }: Props) {
  if (!block.items?.length) return null;

  return (
    <div className="my-8 relative">
      {/* Ligne verticale centrale */}
      <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2 bg-gradient-to-b from-[#d03484]/30 via-[#d47254]/30 to-transparent" />

      <div className="space-y-8">
        {block.items.map((item, idx) => {
          const isRight = item.side === 'right' || (!item.side && idx % 2 !== 0);

          return (
            <div
              key={idx}
              className={`relative flex flex-col md:flex-row items-start md:items-center gap-4 ${isRight ? 'md:flex-row-reverse' : ''}`}
            >
              {/* Dot central */}
              <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-gradient-to-br from-[#d03484] to-[#d47254] shadow-sm border-2 border-white z-10" />

              {/* Contenu */}
              <div className={`w-full md:w-[calc(50%-2rem)] ${isRight ? 'md:pl-8' : 'md:pr-8'}`}>
                <div className="rounded-xl border border-neutral-100 bg-white p-5 shadow-sm">
                  {item.year && (
                    <span className="inline-block text-xs font-semibold text-[#d03484] mb-2 uppercase tracking-wide">
                      {item.year}
                    </span>
                  )}
                  <h4 className="font-semibold text-neutral-900 mb-1">{item.headline}</h4>
                  {item.text && (
                    <p className="text-sm text-neutral-600 leading-relaxed">{item.text}</p>
                  )}
                  {item.image && (
                    <img
                      src={item.image}
                      alt={item.headline}
                      loading="lazy"
                      decoding="async"
                      className="mt-3 w-full rounded-lg object-cover max-h-40"
                    />
                  )}
                </div>
              </div>

              {/* Espace côté opposé (desktop) */}
              <div className="hidden md:block w-[calc(50%-2rem)]" />
            </div>
          );
        })}
      </div>
    </div>
  );
}
